/*=========================================================================================
  File Name: moduleBrand.js
  Description: Brand Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleBookState';
import mutations from './moduleBookMutations.js';
import actions from './moduleBookActions';
import getters from './moduleBookGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
